module.exports = __webpack_public_path__ + "66435bcdade0e9a5f385182ee382f177.png";


//////////////////
// WEBPACK FOOTER
// ./content/about/app-screenshots/search.png
// module id = 1301
// module chunks = 0